import { UserNavigation } from '~/shell/components/UserNavigation';
import { TemplateNavigation } from '~/shell/components/TemplateNavigation';
import type { IWebshopLoginInfoDtoData } from '~/dtos/ProdegaApiWebshop-api-typings-generated';

export interface HeaderNavigationProps {
  loginInfo?: IWebshopLoginInfoDtoData | null;
  isOciSession?: boolean;
}

export function HeaderNavigation({ loginInfo, isOciSession }: Readonly<HeaderNavigationProps>) {
  return (
    <div className={'flex gap-4'}>
      {loginInfo && <TemplateNavigation loginInfo={loginInfo} />}
      <UserNavigation loginInfo={loginInfo} isOciSession={isOciSession} />
    </div>
  );
}
